import {Dropdown} from '@/components/atoms'
import {Constants} from '@/utils/constants/commonConstants'
import {ANY_ID} from '@/utils/constants/promotionConstants'
import {FC} from 'react'
import PromotionSelectionModal from '../../PromotionSelectionModal'
import {RewardItemProps} from './RewardItem'
import {useRewardFreeProducts} from './useRewardFreeProducts'

export const RewardFreeProducts: FC<RewardItemProps> = ({
  promotionCondition,
  index,
  rewardIndex = 0,
  ModalComponent = PromotionSelectionModal,
}) => {
  const {
    isLoadingConfig,
    productTypeOptions,
    buyQtyOptions,
    quantityValue,
    productsValue,
    selectedValuesText,
    isError,
    modalProps,
    modalConditionValues,
    handleBuyCount,
    handleSelectedProductType,
    handleSubmitModal,
    handleCloseModal,
  } = useRewardFreeProducts({promotionCondition, rewardIndex})

  return (
    <div className="flex items-start gap-4">
      <Dropdown
        isJsonWrap={false}
        childList={buyQtyOptions}
        placeholder={ANY_ID}
        updateValue={handleBuyCount}
        isClearable={false}
        autocomplete="off"
        value={quantityValue}
        uiSchema={{style: {maxWidth: '120px'}}}
        loading={isLoadingConfig}
        isError={isError}
        errorMessage="Value Invalid"
      />
      <Dropdown
        isJsonWrap={false}
        childList={productTypeOptions}
        placeholder={selectedValuesText || Constants.AddProducts}
        value={[...productsValue]}
        updateValue={handleSelectedProductType}
        isClearable={true}
        autocomplete="off"
        loading={isLoadingConfig}
        selection="multiple"
        disabled={index > 0}
      />
      <ModalComponent
        key={JSON.stringify(modalProps.type)}
        show={modalProps.show}
        type={modalProps.type}
        onClose={handleCloseModal}
        onSubmit={handleSubmitModal}
        conditionValues={modalConditionValues}
      />
    </div>
  )
}
